import React from 'react';
import { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { AuthProvider } from './contexts/AuthContext';
import { StreamProvider } from './contexts/StreamContext';
import NavBar from './components/Navigation/NavBar';
import RouteConfig from './components/Navigation/RouteConfig';
import { GameProvider } from './contexts/GameContext';

ReactGA.initialize('G-JEGJBXCHEC');

const App = () => {

  useEffect(() => {
    // Send pageview on first load
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  return (
    <AuthProvider>
      <GameProvider>
        <StreamProvider>
          <div className="min-h-screen bg-gray-50">
            <NavBar />
            <main className="container mx-auto px-4 py-8">
              <RouteConfig />
            </main>
          </div>
        </StreamProvider>
      </GameProvider>
    </AuthProvider>
  );
};

export default App;